export default "__VITE_ASSET__CWK05Gs$__"